var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-layout"},[_c('layout-header'),_c('div',{staticClass:"default-layout__wrapper"},[_c('layout-sidebar'),_c('div',{staticClass:"default-layout__page"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }